(() => {

  const SELECTOR = {
    container: ".kb-change-view-buttons",
    front: ".kb-front-view-button",
    back: ".kb-back-view-button",
    reset: ".kb-change-design-button"
  };

  (function () {

  function init() {
    const wrapper = document.querySelector(".kb-wrapper");
    if (!wrapper) {
      setTimeout(init, 500);
      return;
    }

    const addClass = () => {
      const el = document.querySelector("#kitBuilder");
      if (el && !el.classList.contains("container")) {
        el.classList.add("container");
      }
    };

    addClass();

    new MutationObserver(addClass).observe(wrapper, {
      childList: true,
      subtree: true
    });
  }

  init();

})();

  function applyToolbar() {

    const container = document.querySelector(SELECTOR.container);
    const frontBtn = document.querySelector(SELECTOR.front);
    const backBtn = document.querySelector(SELECTOR.back);
    const resetBtn = document.querySelector(SELECTOR.reset);

    // Stop if UI is not loaded yet
    if (!container || !frontBtn || !backBtn || !resetBtn) return;
    // Prevent duplicates
    if (document.querySelector(".kb-toolbar")) return;

    const toolbar = document.createElement("div");
    toolbar.className = "kb-toolbar";
    toolbar.innerHTML = `
      <button class="kb-ui-btn kb-reset-btn"> Reset</button>
      <button class="kb-ui-btn kb-toggle-btn">
       <span class="label"></span>
      </button>
    `;

    const previewTarget =
      document.querySelector(".kb-preview-panel-inner") ||
      container;

    previewTarget.style.position = "relative";
    previewTarget.prepend(toolbar);


    const toggleBtn = toolbar.querySelector(".kb-toggle-btn");
    const resetUI = toolbar.querySelector(".kb-reset-btn");

    resetUI.onclick = () => resetBtn.click();

    function updateLabel() {
      toggleBtn.querySelector(".label").textContent =
        frontBtn.classList.contains("kb-front-view-button-selected")
          ? "Back View"
          : "Front View";
    }

    toggleBtn.onclick = () => {
      frontBtn.classList.contains("kb-front-view-button-selected")
        ? backBtn.click()
        : frontBtn.click();
    };

    frontBtn.style.display = "none";
    backBtn.style.display = "none";
    resetBtn.style.display = "none";

    new MutationObserver(updateLabel).observe(frontBtn, { attributes: true });
    new MutationObserver(updateLabel).observe(backBtn, { attributes: true });

    updateLabel();
  }


  const observer = new MutationObserver(() => {
    applyToolbar();
  });

  function initObserver() {
    const root = document.querySelector(".kb-wrapper");
    if (!root) return setTimeout(initObserver, 500);

    observer.observe(root, { childList: true, subtree: true });
    applyToolbar();
  }

  setInterval(applyToolbar, 1500);

  document.addEventListener("DOMContentLoaded", initObserver);

})();


document.addEventListener("DOMContentLoaded", function () {
  const container = document.querySelector(".kb-wizard-breadcrumbs");
  if (!container) return;

  let items = container.querySelectorAll("li > a, .kb-wizard-breadcrumb > a");
  if (!items.length) {
    items = container.querySelectorAll(".kb-wizard-breadcrumbs li, .kb-wizard-breadcrumbs .kb-wizard-breadcrumb");
  }

  items.forEach((item, idx) => {
    if (item.dataset.enhanced === "1") return;
    item.dataset.enhanced = "1";

    const labelText = item.textContent.trim();
    item.textContent = "";

    const wrapper = document.createElement("span");
    wrapper.className = "kb-step";

    const num = document.createElement("span");
    num.className = "kb-step-number";
    num.textContent = idx + 1;

    const text = document.createElement("span");
    text.className = "kb-step-text";
    text.textContent = labelText;

    wrapper.appendChild(num);
    wrapper.appendChild(text);
    item.appendChild(wrapper);

    const parent = item.closest("li, .kb-wizard-breadcrumb") || item;
    if (idx !== items.length - 1) {
      const arrow = document.createElement("span");
      arrow.className = "kb-step-arrow";
      arrow.textContent = ">";
      parent.after(arrow);
    }
  });
});

(function () {

  const safeWrapperId = "custom-kb-steps";
  let wrapper = null;
  let steps = null;

  /* -----------------------------
     GET ACTIVE STEP INDEX (SYNC)
  ------------------------------ */
  function getActiveIndex() {
    const active = document.querySelector(".kb-wizard-breadcrumb-active");
    if (!active || !steps) return 0;
    return [...steps].indexOf(active);
  }

  const STEP_ICON_MAP = {
  "style": {
    default: "https://cdn.shopify.com/s/files/1/0962/7398/9997/files/style-default.png?v=1771931805",
    active: "https://cdn.shopify.com/s/files/1/0962/7398/9997/files/style-active.png?v=1771936939"
  },
  "logos": {
    default: "https://cdn.shopify.com/s/files/1/0962/7398/9997/files/design-default.png?v=1771931805",
    active: "https://cdn.shopify.com/s/files/1/0962/7398/9997/files/design-active.png?v=1771936881"
  },
  "name & number": {
    default: "https://cdn.shopify.com/s/files/1/0962/7398/9997/files/text-default.png?v=1771931805",
    active: "https://cdn.shopify.com/s/files/1/0962/7398/9997/files/text-active.png?v=1771936924"
  },
  "order": {
   default: "https://cdn.shopify.com/s/files/1/0962/7398/9997/files/finish-default.png?v=1771931805",
     active: "https://cdn.shopify.com/s/files/1/0962/7398/9997/files/finish-active.png?v=1771936906"
  },
  "text customization": {
    default: "https://cdn.shopify.com/s/files/1/0962/7398/9997/files/text-default.png?v=1771931805",
    active: "https://cdn.shopify.com/s/files/1/0962/7398/9997/files/text-active.png?v=1771936924"
  }
};

  /* -----------------------------
     UPDATE TAB STATES
  ------------------------------ */
  function updateActive() {
    if (!steps || !steps.length) return;

    const isDesktop = window.innerWidth > 768;
    const activeIndex = getActiveIndex();
    document.body.classList.toggle("kb-first-step", activeIndex === 0);
    const backBtn = document.querySelector(".kb-button-prev");
  if (backBtn) {
    if (activeIndex === 0) {
      backBtn.style.display = "none";
    } else {
      backBtn.style.display = "inline-flex";
    }
  }

document.querySelectorAll(".kb-step-tab").forEach((tab, index) => {

  tab.classList.remove("active", "completed", "next");

  if (index < activeIndex) tab.classList.add("completed");
  if (index === activeIndex) tab.classList.add("active");
  if (index === activeIndex + 1) tab.classList.add("next");

  const label =
    tab.querySelector(".step-label")?.innerText
      .replace(/\s+/g, " ")
      .trim()
      .toLowerCase();

  const iconSet = STEP_ICON_MAP[label];
  const desktopIcon = tab.querySelector(".step-desktop-icon");

  if (!iconSet) return;

  const src =
    index === activeIndex
      ? iconSet.active
      : iconSet.default;

  // MOBILE
  if (window.innerWidth <= 768) {

    tab.querySelector(".step-circle")?.style.setProperty("display", "none");

    let iconImg = tab.querySelector(".step-mobile-icon");
    if (!iconImg) {
      iconImg = document.createElement("img");
      iconImg.className = "step-mobile-icon";
      tab.prepend(iconImg);
    }

    iconImg.src = src;
  }
  else {
    tab.querySelector(".step-circle")?.style.setProperty("display", "flex");
    tab.querySelector(".step-mobile-icon")?.remove();
  }

  // DESKTOP
  if (desktopIcon) {
    desktopIcon.src = src;
  }

});
  }
  /* -----------------------------
     BUILD CUSTOM TABS
  ------------------------------ */
  function buildTabs() {
    const oldBreadcrumb = document.querySelector(".kb-wizard-breadcrumbs");
    if (!oldBreadcrumb) return;

    steps = oldBreadcrumb.querySelectorAll(".kb-wizard-breadcrumb");
    if (!steps.length) return;

    if (document.getElementById(safeWrapperId)) {
      updateActive();
      return;
    }

    oldBreadcrumb.style.display = "none";

    wrapper = document.createElement("div");
    wrapper.id = safeWrapperId;

    steps.forEach((step, index) => {
      const text =
        step.querySelector(".kb-wizard-breadcrumb-inner")?.innerText.trim() ||
        `Step ${index + 1}`;

      const tab = document.createElement("div");
      tab.className = "kb-step-tab";
      tab.dataset.step = index;
     tab.innerHTML = `
  <div class="step-icon-wrapper">
    <img class="step-desktop-icon" alt="Step Icon" />
  </div>
  <span class="step-label">${text}</span>
`;
      wrapper.appendChild(tab);
    });

    oldBreadcrumb.before(wrapper);

    /* ---------- TAB CLICK ---------- */
    wrapper.addEventListener("click", (e) => {
      const tab = e.target.closest(".kb-step-tab");
      if (!tab) return;

      steps[tab.dataset.step]?.querySelector("a")?.click();
      requestAnimationFrame(updateActive);
    });

    updateActive();

    /* ---------- OBSERVE ACTIVE STEP ---------- */
    const breadcrumbObserver = new MutationObserver(() => {
      requestAnimationFrame(updateActive);
    });

    steps.forEach(step => {
      breadcrumbObserver.observe(step, {
        attributes: true,
        attributeFilter: ["class"]
      });
    });
  }

  buildTabs();

  /* ---------- DOM CHANGES ---------- */
  const observer = new MutationObserver(() => {
    buildTabs();
    requestAnimationFrame(updateActive);
  });

  observer.observe(document.body, { childList: true, subtree: true });

  /* ---------- RESIZE ---------- */
  window.addEventListener("resize", () => {
    requestAnimationFrame(updateActive);
  });

})();
(function () {
  let initialized = false;
  let observer = null;

  let firstSectionExpanded = false; // 🔒 prevents re-opening first section

  const SECTION_ORDER = [
    "base",
    "collar",
    "base color",
    "design colors",
    "sleeve",
    "fabric"
  ];

  function getForm() {
    return document.querySelector(".kb-form, [ng-form='stepForm0']");
  }

  function getSections(form) {
    return Array.from(
      form.querySelectorAll(".kb-form-field-wrapper")
    ).map(wrapper => {
      const header = wrapper.querySelector(".kb-wizard-group-header");
      if (!header) return null;

      return {
        wrapper,
        title: header.textContent.trim().toLowerCase(),
        header
      };
    }).filter(Boolean);
  }

  function reorderOnce() {
    if (initialized) return;

    const form = getForm();
    if (!form) return;

    const sections = getSections(form);
    if (!sections.length) return;

    const fragment = document.createDocumentFragment();

    SECTION_ORDER.forEach(name => {
      const match = sections.find(s => s.title === name);
      if (match) fragment.appendChild(match.wrapper);
    });

    form.appendChild(fragment);

    moveColorIntoCollar();
    // hideFabric();

    initialized = true;

    // 🧹 Stop observing once setup is done
    if (observer) observer.disconnect();
  }

  (function () {

  function ensureBackButton() {

  const nav = document.querySelector(".kb-navigation-buttons");
  if (!nav) return;

  const prevBtn = nav.querySelector(".kb-button-prev");

  // If button does not exist → create one
  if (nav.querySelector(".custom-prev-btn")) return;

  const btn = document.createElement("a");
  btn.className = "kb-button custom-prev-btn";
  btn.textContent = "Back";

  btn.onclick = function () {
    window.history.back();
  };

  nav.prepend(btn);
}

  const observer = new MutationObserver(ensureBackButton);

  function init() {
    const root = document.querySelector(".kb-wrapper");
    if (!root) {
      setTimeout(init, 500);
      return;
    }

    observer.observe(root, {
  childList: true,
  subtree: true,
  attributes: true
});

    ensureBackButton();
  }

  init();

})();

  function expandFirstSectionOnce() {
    if (firstSectionExpanded) return;

    const form = getForm();
    if (!form) return;

    const sections = getSections(form);
    if (!sections.length) return;

    // Find the first section that exists in our order
    let firstSection = null;
    for (const sectionName of SECTION_ORDER) {
      const section = sections.find(s => s.title === sectionName);
      if (section) {
        firstSection = section;
        break;
      }
    }

    if (
      firstSection &&
      firstSection.header &&
      !firstSection.header.classList.contains("kb-wizard-group-header-selected")
    ) {
      setTimeout(() => {
        firstSection.header.click();
        firstSectionExpanded = true;
      }, 150);
    }
  }

  // function hideFabric() {
  //   const fabricSection = [...document.querySelectorAll(".kb-form-field-wrapper")]
  //     .find(w =>
  //       w.querySelector(".kb-wizard-group-header")
  //         ?.textContent.trim().toLowerCase() === "fabric"
  //     );

  //   if (fabricSection) {
  //     fabricSection.style.display = "none";
  //   }
  // }

  function updateNavButtons() {
const prevBtn = document.querySelector(".kb-button.kb-button-prev");  
const nextBtn = document.querySelector(".kb-button-next");
const finishBtn = document.querySelector(".kb-button-finish");

 if (!prevBtn || !nextBtn) return;

  if (prevBtn) prevBtn.textContent = "Back";
  if (nextBtn) nextBtn.textContent = "Next";
  if (finishBtn) finishBtn.textContent = "Save Design";
}

setInterval(updateNavButtons, 1000);


  // 🔐 Respect user interaction forever
  document.addEventListener("click", (e) => {
    if (e.target.closest(".kb-wizard-group-header")) {
      firstSectionExpanded = true;
    }
  });

  // Initial run
  setTimeout(reorderOnce, 200);

  // Observe ONLY until initialized
observer = new MutationObserver(() => {
  const form = getForm();
  if (!form) return;

  // hideFabric();

  if (firstSectionExpanded) return;

  const collarHeader = [...document.querySelectorAll(".kb-wizard-group-header")]
    .find(h => h.textContent.trim().toLowerCase() === "Collar");

  if (!collarHeader) return;

  setTimeout(() => {
    collarHeader.click();
    firstSectionExpanded = true; // LOCK
  }, 300);
});


  observer.observe(document.body, {
    childList: true,
    subtree: true
  });

})();



// custom breadcrumbs script function 
(function () {
  const separatorSVG = `
    <svg xmlns="http://www.w3.org/2000/svg" width="10" height="10" style="margin:0 6px;" fill="currentColor" viewBox="0 0 16 16">
      <path fill-rule="evenodd" d="M3.646 1.646a.5.5 0 0 1 .708 0l6 6a.5.5 0 0 1 0 .708l-6 6a.5.5 0 0 1-.708-.708L9.293 8 3.646 2.354a.5.5 0 0 1 0-.708"/>
      <path fill-rule="evenodd" d="M7.646 1.646a.5.5 0 0 1 .708 0l6 6a.5.5 0 0 1 0 .708l-6 6a.5.5 0 0 1-.708-.708L13.293 8 7.646 2.354a.5.5 0 0 1 0-.708"/>
    </svg>
  `;

  let lastAppliedValue = "";

  function modifyBreadcrumb() {
    const firstCrumb = document.querySelector(".kb-breadcrumbs .kb-breadcrumb a");
    const container = document.querySelector(".kb-breadcrumbs");

    if (!firstCrumb || !container) return;

    const currentData = container.innerText.trim();
    if (currentData === lastAppliedValue) return;

    if (firstCrumb.innerText.trim().toLowerCase() === "kit builder") {
      firstCrumb.innerHTML = `
        <a href="/" style="text-decoration:none;color:inherit;">Home</a>
        ${separatorSVG}
        <a href="/pages/sports-collection" style="text-decoration:none;color:inherit;">Sportswear</a>
      `;

      const items = container.querySelectorAll("li");
      items.forEach((item, index) => {

        const link = item.querySelector("a");

        if (link && index > 0) {
          const previous = items[index - 1]?.innerText.trim().toLowerCase();

          if (previous.replace(/\s+/g, "").includes("sportswear")) {
            const sportKey = link.innerText.trim().toLowerCase().replace(/\s+/g, "-");
            link.href = `/pages/sports-feature-list?sport=${sportKey}`;
          }
        }

        item.querySelectorAll(".breadcrumb-separator").forEach(el => el.remove());

        if (index < items.length - 1) {
          item.insertAdjacentHTML("beforeend", separatorSVG);
        }
      });

    }

    lastAppliedValue = currentData;
  }

  const interval = setInterval(() => {
    const exists = document.querySelector(".kb-breadcrumbs");
    if (exists) modifyBreadcrumb();
  }, 500);

})();

(function () {
  const loader = document.getElementById('kitbuilder-loader');
  if (!loader) return;

  let lastHash = '';

  function showLoader(duration, reason) {
    console.warn(reason);

    loader.style.display = 'block';
    loader.style.opacity = '1';

    setTimeout(() => {
      loader.style.opacity = '0';
      setTimeout(() => {
        loader.style.display = 'none';
      }, 400);
    }, duration);
  }

  function handleRoute() {
    const hash = window.location.hash;

    // prevent re-trigger on same hash
    if (hash === lastHash) return;
    lastHash = hash;

    // PRODUCTS PAGE → 5s loader
    if (hash.includes('/products/')) {
      showLoader(4000, 'KitBuilder products page — loader 5s');
    }

    // CUSTOMISE PAGE → 6s loader
    if (hash.includes('/customise/')) {
      showLoader(6000, 'KitBuilder customise page — loader 6s');
    }
     if (hash.includes('/catalogue/')) {
      showLoader(6000, 'KitBuilder customise page — loader 6s');
    }
  }

  // initial load
  handleRoute();

  // hash route change (SPA navigation)
  window.addEventListener('hashchange', handleRoute);
})();



// (function () {
//   function updateBreadcrumbLinks() {
//     const breadcrumbItems = document.querySelectorAll(".kb-breadcrumbs li a");

//     if (!breadcrumbItems.length) return;

//     breadcrumbItems.forEach((item, index) => {
//       const text = item.innerText.trim().toLowerCase();

//       if (text === "home" || text === "sportswear") return;

//       if (index === breadcrumbItems.length - 1) return;

//       const sportKey = text.replace(/\s+/g, "-").toLowerCase();

//       item.href = `/pages/sports-feature-list?sport=${sportKey}`;
//       item.target = "_self"; 
//     });
//   }

//   const observer = new MutationObserver(updateBreadcrumbLinks);

//   const intervalCheck = setInterval(() => {
//     const breadcrumbContainer = document.querySelector(".kb-breadcrumbs");

//     if (breadcrumbContainer) {
//       updateBreadcrumbLinks();
//       observer.observe(breadcrumbContainer, {
//         childList: true,
//         subtree: true
//       });
//       clearInterval(intervalCheck);
//     }
//   }, 300);
// })();

// (function () {
//   var attempts = 0;
//   var maxAttempts = 40;

//   var intervalId = setInterval(function () {
//     attempts++;

//     var breadcrumbs = document.querySelector(".kb-wizard-breadcrumbs, .kb-breadcrumbs");
//     var preview = document.querySelector(".kb-preview-panel");
//     var editPanel = document.querySelector(".kb-customise-edit-panel");

//     if (!breadcrumbs || !preview || !editPanel) {
//       if (attempts >= maxAttempts) {
//         clearInterval(intervalId);
//       }
//       return;
//     }

//     clearInterval(intervalId);

//     if (document.getElementById("kb-panel-wrapper")) return;

//     var wrapper = document.createElement("div");
//     wrapper.id = "kb-panel-wrapper";

//     breadcrumbs.parentNode.insertBefore(wrapper, breadcrumbs.nextSibling);

//     wrapper.appendChild(preview);
//     wrapper.appendChild(editPanel);
//   }, 500);
// })();

// Show only the Faq on pdp page logic here 
(function () {
  function showFAQForKitbuilder() {
    const faq = document.getElementById("faq-kitbuilder");
    if (!faq) return;

    if (window.location.hash.includes("/customise/")) {
      faq.style.display = "block";
    } else {
      faq.style.display = "none";
    }
  }

  showFAQForKitbuilder();

  window.addEventListener("hashchange", showFAQForKitbuilder);
})();

/* ==========================================
   KITBUILDER – FINAL NO-FLICKER ACCORDION FIX
========================================== */

(function () {

  const FIRST_HEADERS = [
    "collar",
    "base",
    "design colors",
    "line colour",
    "base color"
  ];

  let lastStepKey = null;

  function getStepKey() {
    const hash = window.location.hash || "";
    return hash.split("?")[0]; // product step unique key
  }

  function getVisibleHeaders() {
    return Array.from(
      document.querySelectorAll(
        ".kb-customise-edit-panel .kb-wizard-group-header"
      )
    ).filter(h => h.offsetParent !== null);
  }

  function getHeaderTitle(header) {
    const span = header.querySelector(
      ".kb-wizard-group-header-title"
    );
    return (span ? span.innerText : header.innerText)
      .trim()
      .toLowerCase();
  }

  function openAccordionOncePerStep() {

    const stepKey = getStepKey();

    /* ⭐ already handled for this product */
    if (stepKey === lastStepKey) return;

    const headers = getVisibleHeaders();
    if (!headers.length) return;

    for (let header of headers) {

      const title = getHeaderTitle(header);

      const match = FIRST_HEADERS.some(name =>
        title.includes(name)
      );

      if (!match) continue;

      const alreadyOpen =
        header.classList.contains(
          "kb-wizard-group-header-selected"
        );

      if (!alreadyOpen) {
        console.log("✅ Opening first accordion:", title);
        header.click();
      }

      lastStepKey = stepKey;   // 🔒 LOCK HERE
      return;
    }
  }

  function initObserver() {

    const panel = document.querySelector(
      ".kb-customise-edit-panel"
    );

    if (!panel) {
      setTimeout(initObserver, 500);
      return;
    }

    /* first load */
    setTimeout(openAccordionOncePerStep, 1200);

    /* step change / product change */
    new MutationObserver(() => {
      setTimeout(openAccordionOncePerStep, 400);
    }).observe(panel, {
      childList: true,
      subtree: true
    });

    /* hash navigation */
    window.addEventListener("hashchange", () => {
      setTimeout(openAccordionOncePerStep, 600);
    });

  }

  initObserver();

})();

(function () {

  function addDesignsLinkSection() {

    const kb = document.querySelector(".kb-wrapper");
    if (!kb) return;

    let section = document.getElementById("kb-designs-link");

    // ⭐ CREATE ONLY ONCE
    if (!section) {

      section = document.createElement("div");
      section.id = "kb-designs-link";

      section.innerHTML = `
        <div class="kb-designs-banner">
          <a href="/pages/kitbuilder#/final" class="kb-designs-btn">
            View Saved Designs
          </a>
        </div>
      `;

      kb.parentNode.insertBefore(section, kb);
    }

    // ⭐ VISIBILITY CONTROL
    if (window.location.hash.includes("/customise")) {
      section.style.display = "block";
    }
    else if (window.location.hash.includes("/final")) {
      section.style.display = "none";
    }
    else {
      section.style.display = "none";
    }

  }

  const observer = new MutationObserver(addDesignsLinkSection);

  observer.observe(document.body, {
    childList: true,
    subtree: true
  });

  window.addEventListener("hashchange", addDesignsLinkSection);

  addDesignsLinkSection();

})();